export enum PaymentMethodsEnum {
  Cash = 'CASH',
  CreditCard = 'CREDIT_CARD',
  Idram = 'IDRAM',
  Glovo = 'GLOVO',
  YandexEats = 'YANDEX_EATS',
}
